import { useQuery } from '@tanstack/react-query'
import { api } from '@/shared/api/client'
import { queryKeys } from '@/shared/api/queryKeys'
import type { MinutesInfo } from '@/shared/api/types'

/**
 * Пакет минут компании.
 *
 * Обновляется раз в полминуты: во время обзвона остаток тает на глазах, а
 * чаще дёргать сервер незачем — списание приходит по концу разговора.
 */
export function useMinutes() {
  return useQuery({
    queryKey: queryKeys.minutes,
    queryFn: ({ signal }) => api.get<MinutesInfo>('/minutes', signal),
    staleTime: 15_000,
    refetchInterval: 30_000,
  })
}
